// src/utils/form/formUtils.js
const ISO_RE = /^\d{4}-\d{2}-\d{2}$/;

const parseYMD = (s) => {
  if (!ISO_RE.test(s)) return null;
  const [y, m, d] = s.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  const ok =
    dt.getUTCFullYear() === y &&
    dt.getUTCMonth() === m - 1 &&
    dt.getUTCDate() === d;
  return ok ? dt : null;
};

const todayISO = () => {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const isISODateBetween = (iso, min, max) => {
  const dt = parseYMD(iso);
  const minDt = parseYMD(min);
  const maxDt = parseYMD(max);
  if (!dt || !minDt || !maxDt) return false;
  return dt >= minDt && dt <= maxDt;
};

export { parseYMD, isISODateBetween, todayISO };
